const moment = require('moment-timezone')
const TIMEZONE = 'America/Mexico_City'

function parseTimestamp(value) {
    if (typeof value !== 'string') return null
    const date = moment.tz(value, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.SSSSSS', moment.ISO_8601], true, TIMEZONE)
    return date.isValid() ? date : null
}

function managementDateStatus(value, kind, now = moment().tz(TIMEZONE)) {
    const date = parseTimestamp(value)
    if (!date) return {
        label: kind === 'processed' ? 'Sin datos históricos' : 'Sin fecha registrada',
        color: 'grey',
    }
    const days = now.clone().tz(TIMEZONE).startOf('day').diff(date.clone().startOf('day'), 'days')
    if (kind === 'processed') return {
        label: date.format('DD/MM/YYYY HH:mm'),
        color: days === 0 ? 'success' : 'grey',
    }
    let label = 'Hoy'
    if (days < 0) label = date.format('DD/MM/YYYY HH:mm')
    else if (days > 0) {
        const [count, singular, plural] = days < 7 ? [days, 'día', 'días']
            : days < 30 ? [Math.floor(days / 7), 'semana', 'semanas']
            : days < 365 ? [Math.floor(days / 30), 'mes', 'meses']
            : [Math.floor(days / 365), 'año', 'años']
        label = `Hace ${count} ${count === 1 ? singular : plural}`
    }
    return { label, color: days === 0 ? 'success' : 'grey' }
}

module.exports = { managementDateStatus }
